import { BillingPeriod } from "@redotech/redo-billing-common/service-invoice";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export type RecoverInvoiceStatus = z.infer<typeof recoverInvoiceStatus>;
export const recoverInvoiceStatus = z.object({
  period: createEnum(BillingPeriod),
  billingDueDate: z.date(),
  recoveredRevenueDollars: z.number(),
  recoveredOrdersCount: z.number(),
  revenueSharePercentage: z.number(),
  estimatedInvoiceAmount: z.number(),
  subscriptionFee: z.number(),
  perSmsBillingEnabled: z.boolean(),
  smsCreditsUsed: z.number(),
  smsCreditsIncluded: z.number(),
  smsCarrierFees: z.number(),
});

export const getCurrentRecoverInvoice = {
  name: "getCurrentRecoverInvoice" as const,
  input: z.null(),
  output: recoverInvoiceStatus.nullable(),
};
